package ld;

import pixi.core.display.Container;
import pixi.core.sprites.Sprite;
import pixi.core.textures.Texture;
import pixi.core.display.DisplayObject;

import ld.Types.UIClickMode;
import ld.Types.Vec2;
import pixi.core.math.Point;
import ld.scenes.GameScene;

import stocking.AudioManager;

class GameActionMenu
{
	public var container = new Container();

	var selectedPawn : Pawn = null;
	var clickMode :UIClickMode;
	var map: GameMap;
	var scene: GameScene;
	var changed = true;

	var isInEvent = false;

	public function new( scene: GameScene )
	{
		this.map = scene.map;
		this.scene = scene;
		clickMode = SELECT;
	}

	public function setInEvent( inEvent: Bool )
	{
		isInEvent = inEvent;
	}

	public function show(target: Pawn, state: UIClickMode)
	{
		
		if( target == selectedPawn && !changed )
			return; // Nothing to do!

		changed = false;


		selectedPawn = target;


		var options = getOptions();

		var i=0;

		while( container.children.length > 0 )
			container.removeChildAt(0);

		for( option in options )
		{
			
			var ctn = Util.MakeSideButton( option.name );
			ctn.interactive = true;
			ctn.click = ctn.tap = function( event : pixi.interaction.InteractionEvent ){ option.callback(); };

			ctn.y = i++ * 40;
			container.addChild( ctn );
		}

		if( options.length > 0 )
			container.alpha = 1;
		else
			container.alpha = 0;


		container.children.sort( function( a : DisplayObject, b: DisplayObject ) {
		
			return Math.floor( b.position.y - a.position.y );
		});


		container.x =  104;
		container.y = 210;
		container.scale.x = container.scale.y = 2;

	}

	public function onClick( mouse: Point)
	{
		var target = Util.CoordToTile(mouse);

		if( clickMode == SELECT )
		{
			var victim = map.GetPawnForPosition(target);
			if( victim != null  )
			{
				map.UnPaintAllTiles();
				scene.SelectPawn(  victim );
				AudioManager.instance.play("assets/sfx/Menu Select 1.wav");
			}
		}

		if( clickMode == MOVE || clickMode == ATTACK )
		{
			var victim = map.GetPawnForPosition(target);
			// We wanted to select probably
			if( victim != null && victim.getFaction() == Monster )
			{
				AudioManager.instance.play("assets/sfx/Menu Select 1.wav");
				map.UnPaintAllTiles();
				scene.SelectPawn(  victim );
				clickMode = SELECT;
				return;
			}
		}

		if( clickMode == MOVE )
		{
			map.configureForPawn(selectedPawn);
			var path = map.getRoute(selectedPawn.position, target);
			selectedPawn.moveAlong(path);
			AudioManager.instance.play("assets/sfx/Menu Select 1.wav");
			
			clickMode = SELECT;
			map.UnPaintAllTiles();
			map.PaintTile(selectedPawn.position, 0x999999 );
			changed = true;
		}

		if( clickMode == ATTACK )
		{
			var victim =  map.GetPawnForPosition(target);
			if( victim != null && victim.getFaction() != selectedPawn.getFaction() && selectedPawn.bCanAttackTile( target ))
			{
				AudioManager.instance.play("assets/sfx/Menu Select 1.wav");
				scene.selectedTarget = victim;
				map.UnPaintAllTiles();
				map.PaintTile(selectedPawn.position, 0x999999 );
				selectedPawn.attack( victim, function(){
					clickMode = SELECT;
					scene.DoVictoryChecks();
				} );
				scene.UpdateHud();

				changed = true;
				
			} else {
				AudioManager.instance.play("assets/sfx/MENU B_Back.wav");
			}
		}

		if( clickMode == ABILITY )
		{
			if( selectedPawn.specialAbility == null || !selectedPawn.specialAbility.canTarget( target ) )
				return;

			map.UnPaintAllTiles();
			map.PaintTile(selectedPawn.position, 0x999999 );
			changed = true;

			selectedPawn.specialAbility.execute( target, function(){
				clickMode = SELECT;
				scene.DoVictoryChecks();
			});
			scene.UpdateHud();
			
			
		}

	}

	function getOptions()
	{
		 
		var options = new Array<{name: String, callback: Void->Void}>();
		var activePawn = scene.GetActivePlayerPawn();
		if(  scene.turn != Monster   || selectedPawn == null || selectedPawn != activePawn )
		{
			return options;
		}
		if( selectedPawn.getFaction() == Monster )
		{
			// Add basics
			if( selectedPawn.canMove() )
				options.push({
					name: "Move",
					callback: function(){
						AudioManager.instance.play("assets/sfx/MENU B_Select.wav");
						clickMode = MOVE;
						map.UnPaintAllTiles();
						ShowMoveOptions();
					}
				});

			if( selectedPawn.canAttack() )
				options.push({
					name: "Attack",
					callback: function(){
						AudioManager.instance.play("assets/sfx/MENU B_Select.wav");
						clickMode = ATTACK;
						map.UnPaintAllTiles();
						showAttackOptions();
					}
				});

			if( selectedPawn.specialAbility != null && selectedPawn.bCanAbility )
				options.push({
					name: selectedPawn.specialAbility.name,
					callback: function(){
						AudioManager.instance.play("assets/sfx/MENU B_Select.wav");
						clickMode = ABILITY;
						map.UnPaintAllTiles();
						showAbilityOptions();
					}
				});
		}

		return options;
	}

	function ShowMoveOptions()
	{
		map.configureForPawn(selectedPawn);
		var moveTiles = map.getMoveTargets();	

		for( tile in moveTiles )
		{
			map.PaintTile( tile, 0x9999FF );
		}
	}
	function showAttackOptions()
	{
		var targets = selectedPawn.getAttackTargets();

		for( tile in targets )
		{
			map.PaintTile( tile, 0xFF9999 );
		}

	}

	function showAbilityOptions()
	{
		var targets = selectedPawn.getAbilityTargets();

		for( tile in targets )
		{
			map.PaintTile( tile, 0xFF9999 );
		}

	}
}